"use client";

/* eslint-disable jsx-a11y/iframe-has-title */
import { FC, useEffect, useState } from "react";
import { useSearchParams } from "next/navigation";
import Script from "next/script";

import { Loader } from "components/atoms/Loader/Loader";

import s from "./AirtableForm.module.scss";

interface Props {
  formId: string;
}

enum FormParams {
  referral = "referral",
  is_service = "is_service",
}

export const AirtableForm: FC<Props> = ({ formId }) => {
  const searchParams = useSearchParams();
  const [urlParams, setUrlParams] = useState<any>({
    "hide_Screening options company name": true,
    "hide_Screening options sector": true,
    "hide_Screening options company size": true,
    "hide_Screening options role": true,
    hide_Referral: true,
  });
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    let newUrlParams = {};

    // Convert URLSearchParams to object
    const query: Record<string, string> = {};
    searchParams.forEach((value, key) => {
      query[key] = value;
    });

    Object.keys(query).forEach((key) => {
      const queryItem = query[key];

      if (key === FormParams.referral) {
        newUrlParams = { ...newUrlParams, prefill_Referral: queryItem };
      }

      if (key === FormParams.is_service) {
        newUrlParams = {
          ...newUrlParams,
          "hide_Screening options company name": false,
          "hide_Screening options sector": false,
          "hide_Screening options company size": false,
          "hide_Screening options role": false,
        };
      }
    });

    setUrlParams({ ...urlParams, ...newUrlParams });
    setShowForm(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  if (!showForm) return null;

  return (
    <div className={`${s.AirtableForm} `}>
      <Script src="https://static.airtable.com/js/embed/embed_snippet_v1.js" async defer />
      <div className={s.Loader}>
        <Loader />
      </div>
      <iframe
        src={`https://airtable.com/embed/${formId}?${new URLSearchParams(urlParams).toString()}`}
        className="airtable-embed airtable-dynamic-height"
        frameBorder="0"
        width="100%"
        height="1000"
      />
    </div>
  );
};
